import {captureException} from './client-logger'

let hasReportedMissingNotifications = false

const MISSING_NOTIFICATIONS_PROVIDER_MESSAGE = 'useNotifications must be used within NotificationsProvider'

export const reportMissingNotificationsProvider = (error?: Error) => {
    if (hasReportedMissingNotifications) return
    hasReportedMissingNotifications = true

    captureException(error ?? new Error(MISSING_NOTIFICATIONS_PROVIDER_MESSAGE), {
        event: 'notifications_provider_missing',
        source: 'notifications-provider',
        message: MISSING_NOTIFICATIONS_PROVIDER_MESSAGE,
    })
}
